export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Duration'
    },
    sort: 'play.duration',
    lang: {
        name: 'Play Duration',
        category: ['User', 'Plays'],
        description: 'Duration in minutes of a play.',
        views: ['list', 'sheet'],
        contexts: ['plays']
    },
    filters: ['play.duration']
}